import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Pagination,
    Paper,
    Skeleton,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    Tabs,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useOrganizationStore } from "../../../store/organization.store";
import { useEffect, useState } from "react";
import {
    Organization,
    OrganizationDocument,
    ServiceOrganization,
} from "../../../types/Store/OrganizationStore.types";
import dayjs from "dayjs";

export function OrganizationsPage() {
    const { getServiceOrganizations, getDocumentsByOrganization, getOrganizationInfo, organization } =
        useOrganizationStore();
    const [pageLoading, setPageLoading] = useState(false);
    const [organizationsList, setOrganizationsList] = useState<
        ServiceOrganization[]
    >([]);
    const isMobile = useMediaQuery("(max-width: 700px)")
    const [documents, setDocuments] = useState<OrganizationDocument[]>([]);
    const [activeTab, setActiveTab] = useState<ServiceOrganization>();
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
     const [order, setOrder] = useState<"asc" | "desc">("desc");

    const handleSortDate = () => {
        setOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    };

    const [dialogDocument, setDialogDocument] = useState<OrganizationDocument | null>(null);
    const [dialogOpen, setDialogOpen] = useState(false)

    const handleOpenDialog = (document: OrganizationDocument) => {
        setDialogDocument(document);
        setDialogOpen(true);
    }

    const handleCloseDialog = () => {
        setDialogDocument(null);
        setDialogOpen(false);
    }

    async function getOrganizationsInfo(id: number, page = 0) {
        try {
            setPageLoading(true);
            const data = await getDocumentsByOrganization(id, page, order.toUpperCase());
            if (data){
                setDocuments(data[0]);
                setPageCount(Math.ceil(data[1] / 10));
            }

            await getOrganizationInfo(id)
        } catch (error) {
        } finally {
            setPageLoading(false);
        }
    }

    async function getData() {
        try {
            setPageLoading(true);
            setPage(1)
            const service_organizations = await getServiceOrganizations();
            if (service_organizations) {
                if (service_organizations.length > 0) {
                    setOrganizationsList(service_organizations);
                    setActiveTab(service_organizations[0]);
                    await getOrganizationsInfo(
                        service_organizations[0].id || 0,
                        1
                    );
                    await getOrganizationInfo(service_organizations[0].id)
                }
            }
        } catch (error) {
        } finally {
            setPageLoading(false);
        }
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        if(activeTab) {
            setPage(1)
            getOrganizationsInfo(activeTab.id, page);
        }
    }, [activeTab]);

    useEffect(() => {
        if(activeTab) getOrganizationsInfo(activeTab.id, page);
    }, [page, order])

    const handleChangePage = (event: any, page: number) => {
        setPage(page);
    };

    const handleChangeTab = (event: any, newValue: any) => {
        setActiveTab(organizationsList.find((n) => n.id === newValue) || activeTab);
    };

    return (
        <Box>
            <h1>Обслуживающие организации</h1>

            {pageLoading ? (
                <TableContainer component={Paper}>
                    <Tabs>
                    </Tabs>
                    <Table>
                        <TableHead>
                            <TableCell><Skeleton width={100}/></TableCell>
                            <TableCell><Skeleton width={100}/></TableCell>
                            <TableCell><Skeleton width={100}/></TableCell>
                            {!isMobile && <TableCell><Skeleton width={100}/></TableCell>}
                        </TableHead>
                        <TableBody>
                            {new Array(10).fill(0).map((n, v) => {
                                return (
                                    <TableRow key={v}>
                                        <TableCell><Skeleton width={100}/></TableCell>
                                        <TableCell><Skeleton width={100}/></TableCell>
                                        <TableCell><Skeleton width={100}/></TableCell>
                                        {!isMobile && <TableCell><Skeleton width={100}/></TableCell>}
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                </TableContainer> // (organizationsList.length === 0 && !pageLoading)
            ) : (
                <TableContainer component={Paper} sx={{maxWidth: isMobile ? "calc(100vw - 48px)" : "auto"}}>
                    <Tabs value={activeTab?.id} onChange={handleChangeTab}>
                        {organizationsList.map((n) => {
                            return (
                                <Tab key={n.id} value={n.id} label={n.name} />
                            );
                        })}
                    </Tabs>
                    <Box sx={{
                        padding: "10px"
                    }}>
                        <Typography>Номер телефона: {organization?.contact_number}</Typography>
                        <Typography>Электронная почта: {organization?.email}</Typography>
                        <Typography>Адрес: {organization?.legal_address}</Typography>
                        <Typography>{organization?.description}</Typography>
                    </Box>
                    <Table>
                        <TableHead>
                            {!isMobile && <TableCell>Название</TableCell>}
                            {!isMobile && <TableCell>Описание</TableCell>}
                            <TableCell sortDirection={order}>
                                <TableSortLabel
                                    active
                                    direction={order}
                                    onClick={handleSortDate}
                                >
                                    Дата {isMobile && " и заголовок"}
                                </TableSortLabel>
                            </TableCell>
                            <TableCell>Ссылка</TableCell>
                        </TableHead>
                        <TableBody>
                            {documents.map((n) => {
                                return (
                                    <TableRow key={n.id}>
                                        <TableCell><Typography>{n.title}</Typography> {isMobile && dayjs(n.created_at).format("DD.MM.YYYY")}</TableCell>
                                        {!isMobile && <TableCell>
                                            {n.description && (n?.description?.length <= 60 ? (
                                                n.description
                                            ) : (
                                                <>
                                                    {n.description.slice(0, 60)}
                                                    ...{" "}
                                                    <a href="#" onClick={() => handleOpenDialog(n)}>
                                                        Посмотреть полностью
                                                    </a>
                                                </>
                                            ))}
                                        </TableCell>}
                                        {!isMobile && <TableCell>
                                            {dayjs(n.created_at).format(
                                                "DD.MM.YYYY",
                                            )}
                                        </TableCell>}
                                        <TableCell>
                                            {n.resource_url && <a style={{wordBreak:"break-all"}} href={n.resource_url}>
                                                {n?.resource_url?.length <= 60
                                                    ? n.resource_url
                                                    : n.resource_url.slice(
                                                          0,
                                                          60,
                                                      ) + "..."}
                                            </a>}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            margin: "16px 0",
                        }}
                    >
                        <Pagination count={pageCount} page={page} onChange={handleChangePage}/>
                    </Box>
                </TableContainer>
            )}

            <Dialog open={dialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>{dialogDocument?.title}</DialogTitle>
                <DialogContent>
                    <Typography sx={{
                        textWrap:"wrap",
                        wordBreak:"break-word"
                    }}>{dialogDocument?.description}</Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Закрыть</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
